import Vue from 'vue';
import Vuex from 'vuex';

import storeData from '../data.json';

Vue.use(Vuex);

const SLIDE_PREV = 'prev';
const SLIDE_NEXT = 'next';
const SLIDE_CURRENT = 'current';

const currentMonth = () => {
  const now = new Date();
  return now.getMonth() + 1;
};

storeData.activeMonth = currentMonth();
storeData.way = '';
storeData.search = '';

const store = new Vuex.Store({
  state: storeData,
  getters: {
    slideWay: state => `slide-${state.way}`,
    prevMonth: (state) => {
      if (state.activeMonth === 1) { return 12; }
      return state.activeMonth - 1;
    },
    nextMonth: (state) => {
      if (state.activeMonth === 12) { return 1; }
      return state.activeMonth + 1;
    },
    getActiveMonthCategory: state => category =>
      state[category]
        .filter(one => one.months.indexOf(state.activeMonth) > -1)
        .sort((a, b) => {
          if (a.fr < b.fr) return -1;
          if (a.fr > b.fr) return 1;
          return 0;
        })
  },
  mutations: {
    setActiveMonth: (state, payload) => {
      state.way = payload.way;
      state.activeMonth = payload.month;
    },
    setSearch: (state, value) => {
      state.search = value;
    }
  },
  actions: {
    goBackward: ({ commit, getters }) => {
      const newActiveMonth = getters.prevMonth;
      commit('setActiveMonth', { month: newActiveMonth, way: SLIDE_PREV });
    },
    goForward: ({ commit, getters }) => {
      const newActiveMonth = getters.nextMonth;
      commit('setActiveMonth', { month: newActiveMonth, way: SLIDE_NEXT });
    },
    goCurrent: ({ commit }) => {
      commit('setActiveMonth', { month: currentMonth(), way: SLIDE_CURRENT });
    },
    updateSearch: ({ commit }, value) => {
      commit('setSearch', value);
    },
  }
});

export default store;
